import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { isExternalHref } from 'bundles/enterprise-admin-navigation/utils/navConfigUtils';

/**
 * Returns an onClick handler that navigates internally via the router (no full page reload).
 * Only intercepts primary clicks. Allows modified clicks to use default browser behavior:
 * - Cmd/Ctrl + click → Opens in new tab
 * - Shift + click → Opens in new window
 * - Alt + click → Downloads
 * - Middle/right-click → Uses context menu
 */
export function useInternalNavClick(href: string | undefined): (e: React.MouseEvent<HTMLAnchorElement>) => void {
  const router = useRouter();
  return React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!href) return;
      // Skip when external, target=_blank, modified-click, or non-primary mouse button.
      if (
        isExternalHref(href) ||
        (e.currentTarget.target && e.currentTarget.target !== '_self') ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey ||
        e.button !== 0
      ) {
        return;
      }
      e.preventDefault();
      router.push(href);
    },
    [href, router]
  );
}
